<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card class="h-auto">
          <div slot="footer">
            <b-row>
              <b-col sm="12">
                <b-button variant="primary" class="float-right mr-3" disabled v-if="loading">
                  <b-spinner small type="grow"></b-spinner>
                  Loading...
                </b-button>
                <button v-else
                        class="btn btn-primary float-right mr-3"
                        type="button" @click="downloadWithAxios"
                >{{ $t('page.generic.generate') }}
                </button>
                <button class="btn btn-warning float-right mr-3"
                        type="button" @click="resetExample"
                >{{ $t('page.generic.reset') }}
                </button>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col sm="7">
              <b-row>
                <b-form-group>
                  <label>Codice</label>
                  <codemirror class="h-100" ref="vueCm" v-model="example" :options="editorOption"></codemirror>
                </b-form-group>
              </b-row>
            </b-col>
            <b-col sm="5">
              <simulation-list :model-code="code" v-model.sync="currentSimulation"></simulation-list>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import PageTitle from "../../components/PageTitle";
  import SimulationList from "../../components/modelsimulation/SimulationList";
  import Vue from "vue";
  import VueCodeMirror from "vue-codemirror";
  import miniToastr from 'mini-toastr' //ES6
  // require styles
  import "codemirror/lib/codemirror.css";
  import "codemirror/theme/eclipse.css";
  import "codemirror/mode/xml/xml";

  import ModelService from '@/services/ModelService'

  var db = require('mime-db');

  const modelService = ModelService.build();

  //import test from './test.xml'

  // global use
  Vue.use(VueCodeMirror);

  export default {
    name: "modelSimulation",
    components: {
      PageTitle,
      SimulationList
    },
    props: {
      code: {
        required: true
      }
    },
    watch: {
      currentSimulation: function (val) {
        if(val && val.id){
          this.fetchSimulationData(val.id)
        } else {
          this.example = ''
        }
      }
    },
    data() {
      return {
        example: '',
        currentSimulation: undefined,
        simulations: [],
        editorOption: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          lineWrapping: true,
          line: true,
          mode: 'application/xml',
          autofocus: true
        },
        modelData: {},
        loading: false
      };
    },
    computed: {
      codemirror() {
        return this.$refs.vueCm.codemirror;
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon("error", "i", {class: "fas fa-exclamation-triangle"});
      miniToastr.setIcon('success', 'i', {'class': 'far fa-check'});
    },
    methods: {
      forceFileDownload(response) {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.getFilename(response)); //or any other extension
        document.body.appendChild(link);
        link.click();
        setTimeout(function(){
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(url);
        }, 100);
        miniToastr.success('Simulazione richiesta completata con successo')
      },
      getFilename(response){
          let filename = this.currentSimulation.modelCode;
          let mimeDb = db[response.headers['content-type']];
          if (mimeDb && mimeDb.extensions){
              filename += `.${mimeDb.extensions[0]}`
          }
          return filename
      },
      async downloadWithAxios() {
        try {
          this.loading = true;
          let response = await modelService.make(this.example);
          this.forceFileDownload(response);
          this.loading = false
        } catch (e) {
          miniToastr.error(e.message);
          this.loading = false
        }
      },
      resetExample() {
        this.currentSimulation = undefined;
      },

      async fetchSimulationData(id){
        try{
          let simulationModel = await modelService.simulation(id);
          this.example = simulationModel.content;
        } catch (e) {
          //miniToastr.success("Errore nel caricamento della simulazione: " + id);
          console.error("Errore nel caricamento della simulazione: " + id)
        }
      }

    }
  };
</script>
